import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { Button } from "@repo/ui/button";
import { LinkButton } from "@repo/ui/link-button";
import { Link } from "@/i18n/navigation";
import { ActionLink } from "@/components/common/actions/actions.component";
import { getI18nString } from "@/lib/utils";
import type { PrimaryMenuItem, UtilityMenuItem } from "@/components/navigation/navigation.types";
interface MobileMenuLevel2Props {
  menuItems: PrimaryMenuItem[] | null;
  utilityItems: UtilityMenuItem[] | null;
  onSelectSection: (id: string) => void;
  /** Mirrors the desktop CTA's audience gating — hidden for the businesses tab. */
  showPlanVisitCta: boolean;
}
export function MobileMenuLevel2(t0) {
  const $ = _c(14);
  const {
    menuItems,
    utilityItems,
    onSelectSection,
    showPlanVisitCta
  } = t0;
  const t = useTranslations("navigation");
  let t1;
  if ($[0] !== showPlanVisitCta || $[1] !== t) {
    t1 = showPlanVisitCta && <Button variant="blue-filled" size="sm" asChild={true} className="w-full"><Link href="/plan-your-visit">{t("planYourTrip")}</Link></Button>;
    $[0] = showPlanVisitCta;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== menuItems || $[4] !== onSelectSection) {
    t2 = menuItems && menuItems.length > 0 && <nav aria-label="Main navigation"><ul className="flex flex-col border-t border-border-subtle">{menuItems.map(menu => <li key={menu.id} className="border-b border-border-subtle pb-5 pt-3 last:border-b-0">{menu.type === "action" ? <ActionLink actionTo={menu.to ?? undefined} className="typography-component-sm-medium flex w-full items-center py-1 text-left text-text-primary">{menu.heading}</ActionLink> : <button type="button" onClick={() => onSelectSection(menu.id)} className="typography-component-sm-medium flex w-full items-center py-1 text-left text-text-primary">{menu.heading}</button>}</li>)}</ul></nav>;
    $[3] = menuItems;
    $[4] = onSelectSection;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex flex-col gap-4">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== utilityItems) {
    t4 = utilityItems && utilityItems.length > 0 && <nav aria-label="Utility links" className="py-4"><ul className="flex flex-col gap-3">{utilityItems.map(_temp)}</ul></nav>;
    $[9] = utilityItems;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className="flex flex-col justify-between h-full">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function _temp(item) {
  return item?.to ? <li key={item._id}><LinkButton asChild={true} variant="primary" size="sm"><ActionLink actionTo={item.to}>{getI18nString(item.text, "Link")}</ActionLink></LinkButton></li> : null;
}